import React, { FC, useCallback } from "react"
import { selectSortingPreference, setSort } from "../bookingsSlice"
import { useAppDispatch, useAppSelector } from "../../hooks"


interface BookingsListHeaderProps {
  column: string;
  children: React.ReactNode
}

const BookingsListHeader: FC<BookingsListHeaderProps> = ({ column, children }) => {
  const dispatch = useAppDispatch()
  const sortPreference = useAppSelector(selectSortingPreference)
  const sortIcon = `${sortPreference.column === column ? `sorted ${sortPreference.direction.toLowerCase()}` : ''}`

  const handleClick = useCallback(() => {
    dispatch(setSort({
      column,
      direction: sortPreference.column === column ? (sortPreference.direction === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
    }))
  }, [sortPreference, dispatch, column])

  return (
    <span onClick={handleClick} className={sortIcon}>{children}</span>
  )
}


export default BookingsListHeader